import React from 'react';

import cn from '@/helpers/utils/classNames';

import { HeadingProps } from '../propTypes';
import { headingStyles } from '../styles';

const HeadingThree = ({ className, variant = 'primary', children, ...rest }: HeadingProps) => {
  return (
    <h3
      className={cn(
        headingStyles({
          color: variant,
        }),
        'sm:text-xl md:text-2xl lg:text-[1.8rem] xs:text-[1.25rem] xxs:text-lg',
        className
      )}
      {...rest}
    >
      {children}
    </h3>
  );
};

export default HeadingThree;
